// extracted by mini-css-extract-plugin
export default {"scheduledDeletionWrapper":"zZ2YGyNq5bVGodjGHPbQ","incoming":"qIwX1riG0rEQIvjGIc7w","outgoing":"Kw5_PzVp12FxM2CLfBhL"};